/** "While you were away": what your friends and the planet did since your last visit. */
import type { JSX } from 'react';

import { closePanel } from '@game/view/panels';
import { t } from '@i18n/index';
import { Face, Sheet, SHEET_LEAVE_MS } from '@ui/components/Sheet';
import { useGame, useGameState, useLocale } from '@ui/hooks';

export function AwayPanel(): JSX.Element | null {
  useLocale();
  const game = useGame();
  const away = useGameState((s) => s.away);
  const members = useGameState((s) => s.members);
  if (!away) return null;
  const close = (): void => {
    closePanel(game);
    setTimeout(() => game.store.set({ away: null }), SHEET_LEAVE_MS + 20);
  };
  const lines: { color: string; text: string }[] = [];
  for (const [id, n] of Object.entries(away.changes)) {
    lines.push({
      color: members.get(id)?.color ?? '#999999',
      text: t('away.changes', { name: members.get(id)?.name ?? t('hud.crewmate'), n }),
    });
  }
  if (away.grew) lines.push({ color: '#8DBF74', text: t('away.saplings', { n: away.grew }) });
  if (away.fell) lines.push({ color: '#B9C6D6', text: t('away.fell', { n: away.fell }) });
  if (away.sank) lines.push({ color: '#7FB3DC', text: t('away.sank', { n: away.sank }) });
  if (away.laid) lines.push({ color: '#7DBB55', text: t('away.laid', { n: away.laid }) });
  if (away.shattered)
    lines.push({ color: '#E0609E', text: t('away.shattered', { n: away.shattered }) });
  return (
    <Sheet id="away" title={t('away.title')} onClose={close}>
      <ul className="list away">
        {lines.map((line) => (
          <li key={line.text}>
            <Face color={line.color} />
            <span className="who">{line.text}</span>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
